import nlnAxios from "../../../api/nlnAxios";
import {toast} from 'react-toastify'

//Create Resources

const createResourceCategory = async (resourceCategoryData, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}

    const response = await nlnAxios.post("/library/resources/categories", resourceCategoryData);
    return response.data

}

//Edit Resources
const editResourceCategory = async (resourceCategoryData, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}

    const response = await nlnAxios.patch(`/library/resources/categories/${resourceCategoryData.resourceCategoryId}`, resourceCategoryData);
    return response.data

}


//Get Resources

const getResourceCategory = async (token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}

    const response = await nlnAxios.get("/library/public/resources/categories/?resourceType=internal");

    return response.data;
}

const getAllResourceCategory = async (token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}

    const response = await nlnAxios.get("/library/resources/categories/");

    return response.data;
}


//Get Resources

// const getExternalResources = async (token) => {

//     const config = {
//         headers: {
//             Authorization: `Bearer ${token}`
//     }
// }

//     const response = await nlnAxios.get("/library/public/resources/categories/?resourceType=external");

//     return response.data;
// }


//Delete resource category 
const deleteResourceCategory = async (resourceCategoryId, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }

    }

    const response = await nlnAxios.delete("/library/resources/categories/" + resourceCategoryId);

    return response.data;
}

const resourceCategoryService = {
    createResourceCategory,
    editResourceCategory,
    getResourceCategory,
    getAllResourceCategory,
    deleteResourceCategory
}

export default resourceCategoryService;